//Generated File 
export const ATTACHMENT = `ATTACHMENT`;
export const BIGDECIMAL = `BIGDECIMAL`;
export const BOOLEAN = `BOOLEAN`;
export const DATE = `DATE`;
export const ENTITYREFERENCE = `ENTITYREFERENCE`;
export const FLATOBJECT = `FLATOBJECT`;
export const FLATOBJECTLIST = `FLATOBJECTLIST`;
export const GUI2FlatObject = `GUI2FlatObject`;
export const GUI2List = `GUI2List`;
export const GUI2WholeEntity = `GUI2WholeEntity`;
export const INTEGER = `INTEGER`;
export const LONG = `LONG`;
export const NORMALLIST = `NORMALLIST`;
export const STRING = `STRING`;
